import { RemoveCartEntryProps } from '../../../types';
import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { getActiveCartId, getActiveUserId } from '../../../helpers';
import { DeleteFromCartProps } from '@vsf-enterprise/sapcc-api';
import { Context } from '@vue-storefront/core';

export async function removeCartEntry(
  context: Context,
  params: RemoveCartEntryProps,
  currentCart: Cart
): Promise<Cart> {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  const props: DeleteFromCartProps = {
    ...params,
    cartId: getActiveCartId({ cookies: $cookies, currentCart }),
    userId: getActiveUserId($cookies)
  };

  return context.$sapcc.api.deleteCartEntry(props);
}
